import React from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';
import SectionHeader from 'views/SectionHeader.js';

// Combined trust story: the heritage framing explains why the numbers are
// impressive despite no online footprint, a one-line summary substantiates the
// claim, and the coverage map shows that installed base coast to coast. The
// numbers stay quiet so the map is the visual: one line on desktop, and on
// phones the same line with short labels between two thin rules.
// Drop the exported map image at /public/images/coverage-map.png.
const coverageMapImage = '/images/coverage-map.png';

const Stats = () => {

    const mobile = Utils.isMobile();

    const stats = [
        { value: '73K+', label: 'homes protected', short: 'homes' },
        { value: '969K+', label: 'sensors deployed', short: 'sensors' },
        { value: '130+', label: 'partners nationwide', short: 'partners' },
    ];

    return (
        <section style={{
            width: '100%',
            backgroundColor: Appearance.colors.offWhite,
        }}>
            <div style={{
                maxWidth: Appearance.layout.maxWidth,
                margin: '0 auto',
                padding: Appearance.layout.sectionPadding(),
                textAlign: 'center',
            }}>

                <SectionHeader
                    eyebrow={'Now available online for the first time'}
                    title={'A decade of protection, now available to everyone'}
                    subtitle={'For over a decade, our protection was available only through authorized distributors and in-home specialists. Today, for the first time, you can order it directly.'}
                    style={{ marginBottom: mobile ? 18 : 28 }} />

                {/* Summary — the proof of the installed base, in one line */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'baseline',
                    flexWrap: mobile ? 'nowrap' : 'wrap',
                    gap: mobile ? 8 : '8px 20px',
                    whiteSpace: mobile ? 'nowrap' : 'normal',
                    fontFamily: Appearance.fonts.body,
                    fontSize: mobile ? 13 : 17,
                    color: Appearance.colors.subText(),
                    marginBottom: mobile ? 22 : 32,
                    ...(mobile ? {
                        borderTop: `1px solid ${Appearance.colors.border()}`,
                        borderBottom: `1px solid ${Appearance.colors.border()}`,
                        padding: '12px 0',
                    } : {}),
                }}>
                    {stats.map((stat, index) => (
                        <React.Fragment key={index}>
                            {index > 0 && (
                                <span style={{
                                    width: mobile ? 3 : 4,
                                    height: mobile ? 3 : 4,
                                    borderRadius: '50%',
                                    alignSelf: 'center',
                                    backgroundColor: mobile ? Appearance.colors.lightGrey : Appearance.colors.border(),
                                }} />
                            )}
                            <span>
                                <b style={{
                                    fontFamily: Appearance.fonts.heading,
                                    fontWeight: 600,
                                    fontSize: mobile ? 16 : 22,
                                    letterSpacing: '-0.02em',
                                    fontVariantNumeric: 'tabular-nums',
                                    color: Appearance.colors.text(),
                                    marginRight: mobile ? 3 : 6,
                                }}>
                                    {stat.value}
                                </b>
                                {mobile ? stat.short : stat.label}
                            </span>
                        </React.Fragment>
                    ))}
                </div>

                {/* Coverage map */}
                <div>
                    <div style={{
                        position: 'relative',
                        width: '100%',
                        paddingTop: '50%',
                        borderRadius: 16,
                        overflow: 'hidden',
                        border: `1px solid ${Appearance.colors.border()}`,
                        boxShadow: Appearance.boxShadow.card,
                        backgroundColor: Appearance.colors.lighterGrey,
                    }}>
                        <img
                            src={coverageMapImage}
                            alt={'Map of protected homes across North America'}
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                            }} />
                    </div>
                    <p style={{ ...Appearance.textStyles.caption({ color: Appearance.colors.subText() }), marginTop: 16 }}>
                        {'Every point is a home already on the Aqua Link network.'}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Stats;
